import { connect, mapProps, mapReadPretty } from '@formily/react'
import { Switch as AntdSwitch } from 'antd'

export const Switch = connect(
  AntdSwitch,
  mapReadPretty(AntdSwitch, {
    disabled: true
  }),
  mapProps({
    value: 'checked'
  })
)
